'use strict';

var ReferenceValueToggleDirective = function ReferenceValueToggleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/reference-value-toggle.html'),
    controller: 'ReferenceValueToggleController',
    scope: {
      screenState: '='
    }
  };
};
ReferenceValueToggleDirective.$inject = [];
module.exports = ReferenceValueToggleDirective;